export const enum UserApiRole {
  Admin = "Admin",
  Superadmin = "Superadmin",
  User = "User",
  Superuser = "Superuser",
}

export const enum UserAppRole {
  MallViewer = "mall-viewer",
  ShopViewer = "shop-viewer",
  StationViewer = "station-viewer",
  InsightViewer = "insight-viewer",
  DocumentViewer = "document-viewer",
}
